import React from 'react';
import Main from './components/MainComponent'
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import './App.css';

function App() {
  const theme = createTheme({
  typography: {
    h4: {
      fontFamily: "'Poppins', sans-serif",
      color: '#900309',
      // color: '#19293a',
      fontWeight: 'bold'
    },
    h1: {
      fontFamily: "'Poppins', sans-serif",
      color: '#900309',
    },
    h5: {
      fontFamily: "'Poppins', sans-serif",
      color: '#900309',
    },
    h6: {
      fontFamily: "'Poppins', sans-serif",
      color: '#900309',
      fontWeight: 'bold'
    },
    body1: {
      fontFamily: "'Poppins', sans-serif",
    },
    body2: {
      fontFamily: "'Poppins', sans-serif",
    },
    subtitle1: {
      fontFamily: "'Poppins', sans-serif",
    }
  },
  palette: {
    primary: {
      main: '#900309', // or your desired primary color
    },
    secondary: {
      main: '#900309', // 🔧 change this to the background color you want for your secondary button
      contrastText: '#ffffff', // optional: sets text color for contrast
    },
    background: {
      default: '#ffffff',
    },
    text: {
      primary: '#900309',
    },
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "'Poppins', sans-serif",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Poppins', sans-serif",
          textTransform: 'none',
          fontWeight: 'bold'
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: "'Poppins', sans-serif",
      },
    },
  },
  },
});


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Main/>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
